import { formatViewInterval } from "@suse-o11y/date-time/format/format-view-interval";
import type { Time } from "@suse-o11y/date-time/time";

export interface FormatTimeParams {
	time: Time;
	timelineStart: Time;
	timelineEnd: Time;
	now: Time;
}

export const formatTime = ({ time, timelineStart, timelineEnd, now }: FormatTimeParams): string =>
	formatViewInterval({
		interval: [timelineStart, timelineEnd],
		now,
		viewTime: timelineEnd,
		alwaysUseSecondsFormat: true,
	}).format(time);
